import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useMatch,
  useResolvedPath,
} from "react-router";

export const withRouter = (Child) => {
  return (props) => {
    const param = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    let resolved = useResolvedPath(location.pathname);
    let match = useMatch({ path: resolved.pathname, end: true });
    return (
      <Child
        {...props}
        location={location}
        match={match}
        param={param}
        navigate={navigate}
      />
    );
  };
};
